/* eslint-disable @typescript-eslint/indent */
import { createApi } from '@reduxjs/toolkit/query/react';
import { TServerResponse } from 'app/types/server-response';
import { authAPIBase } from 'app/utilities/env';
import getBaseQueryWithLogout from 'app/utilities/getBaseQuery';

import { DebitWalletDTO, TWallet } from '../types/wallet';

export const walletApiSlice = createApi({
  reducerPath: 'walletsApi',
  baseQuery: getBaseQueryWithLogout(`${authAPIBase}/wallet`),
  tagTypes: ['Wallet'],
  endpoints: (build) => ({
    fundWallet: build.mutation<string, Record<'holderId' | 'amount', number>>({
      query: (body) => ({
        url: '/fund-wallet',
        method: 'POST',
        body,
      }),
      transformResponse: (res: TServerResponse<string>) => res.data,
      invalidatesTags: ['Wallet'],
    }),

    getWalletBalance: build.query<TWallet, number>({
      query: (id) => `/get-balance/${id}`,
      transformResponse: (res: TServerResponse<TWallet>) => res.data,
      providesTags: ['Wallet'],
    }),

    debitWallet: build.mutation<string, DebitWalletDTO>({
      query: (body) => ({
        url: '/debit-wallet',
        method: 'POST',
        body,
      }),
      transformResponse: (res: TServerResponse<string>) => res.data,
      invalidatesTags: ['Wallet'],
    }),
  }),
});

export const {
  useFundWalletMutation,
  useGetWalletBalanceQuery,
  useLazyGetWalletBalanceQuery,
  useDebitWalletMutation,
} = walletApiSlice;
